import { render, staticRenderFns } from "./taskDetailView.vue?vue&type=template&id=0fad4ba4&"
import script from "./taskDetailView.vue?vue&type=script&lang=js&"
export * from "./taskDetailView.vue?vue&type=script&lang=js&"
import style0 from "./taskDetailView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports